import { User } from '../../interfaces/entities/user'

export type Type = User & { loading?: boolean }

export const initial: Type = {
  fullName: '',
  email: '',
  groups: ['client'],
  restrictedAccess: true,
}
